<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <Header/>

      <b-card class="bCardAgenda">
        <b-container fluid="">
          <b-row class="divSubtitulo m-1 mb-3">
            <b-col cols="6" md="10">
              <div>
                <p class="textoSubtitulo">Administración de clínicas</p>
              </div>
            </b-col>
            <b-col cols="6" md="2">
              <div>
                <p style="text-align:end" class="textoSubtitulo">CÓDIGO: BO_28</p>
              </div>
            </b-col>
          </b-row>
        </b-container>

        <div class="mt-2 col-md-12"></div>

        <b-container fluid="">
            <b-row>
                <b-col>
                    <b-tabs class="md-transparent borderGray">

                        <b-tab lazy
                                v-if="$localStorageService.can('BO_28_clini_Activa')"
                                id="tab-clinicasactivas"
                                title="Clínicas Activas"
                                class="borderGray paddingTab"
                        >
                            <clinicasActivas :filtro="filtro" @actualizarFiltro="actualizarFiltro"/>
                        </b-tab>

                        <b-tab lazy
                                v-if="$localStorageService.can('BO_28_clini_Inactiva_Inact')"
                                id="tab-clínicasInactivas"
                                title="Clínicas Inactivas"
                                class="matTabMapa paddingTab"
                        >
                            <clinicasInactivas :filtro="filtro" @actualizarFiltro="actualizarFiltro"/>
                        </b-tab>

                        <b-tab
                                v-if="$localStorageService.can('BO_28_clini_alta_tipoClin')"
                                id="tab-altaTipo"
                                title="Alta de Tipo de Clínicas"
                                class="paddingTab">
                            <altaTipoClinica/>
                        </b-tab>

                    </b-tabs>
                </b-col>
            </b-row>
        </b-container>
      </b-card>
    </div>

</template>
<script>

    //components
    import Header from "../../components/Header.vue";
    import clinicasActivas from "../perfilPacientes/clinicasActivas.vue";
    import clinicasInactivas from "../perfilPacientes/clinicasInactivas.vue";
    import altaTipoClinica from "../perfilPacientes/altaTipoClinica.vue";

    export default {
        name: "Patient",
        components: {
            Header,
            clinicasActivas,
            clinicasInactivas,
            altaTipoClinica,
        },
        props: {
            msg: String,
            isDark: Boolean,
            "md-active-step": String,
        },
        data: () => ({
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,

          filtro: ''
        }),
        methods: {
            actualizarFiltro(filtro) {
                this.filtro = filtro;
            }
        },
      created() {
        this.debug = this.$localStorageService.getDebug();
      }

    };
</script>
<style scoped>
.bCardAgenda {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardAgenda .card-body {
  padding: 0.5rem;
}
</style>